import { success } from "toastr";
import {
  FETCH_CLIENT,
  FETCH_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
  GENERATE_CLIENT_CODE,
  GENERATE_CLIENT_CODE_SUCCESS,
  GENERATE_CLIENT_CODE_FAILURE,  
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  DELETE_CLIENT,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAILURE,  
  CHANGE_CLIENT_STATUS,
  CHANGE_CLIENT_STATUS_SUCCESS,
  CHANGE_CLIENT_STATUS_FAILURE,
  FETCH_ACTIVE_CLIENT_REQUEST,
  FETCH_ACTIVE_CLIENT_SUCCESS,
  FETCH_ACTIVE_CLIENT_FAILURE,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS,
  FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE
} from "./actionTypes";

const initialState = {
  client: [],
  clientCode:'',
  clientActiveList:[],
  accountList: [],
  loading: false,
  error: null,
  success:false
};

const timesheetSetupClientReducer = (state = initialState, action) => {
 
  switch (action.type) {
    case FETCH_CLIENT:
      return { ...state, loading: true };
    case FETCH_CLIENT_SUCCESS:
      return { ...state, loading: false, client: action.payload.data};
    case FETCH_CLIENT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GENERATE_CLIENT_CODE:
      return { ...state, loading: true };
    case GENERATE_CLIENT_CODE_SUCCESS:
      return { ...state, loading: false, clientCode: action.payload.data};
    case GENERATE_CLIENT_CODE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case CHANGE_CLIENT_STATUS:
      return { ...state, loading: true, error: null, success: false };

    case CHANGE_CLIENT_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case CHANGE_CLIENT_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case CREATE_CLIENT_REQUEST:
      return { ...state, loading: true, success:false, error: null };
    
    case CREATE_CLIENT_SUCCESS:
      return { ...state, loading: false, success:true, deductionData: action.payload, error: null };

    case CREATE_CLIENT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };

    case DELETE_CLIENT:
      return { ...state, loading: true, success:false, error: null }; // Clear previous errors
    
    case DELETE_CLIENT_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };
    
    case DELETE_CLIENT_FAILURE:
      return { ...state, loading: false, success:false, error: action.payload };
      
    case FETCH_ACTIVE_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ACTIVE_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        clientActiveList: (action.payload?.data).map(client => ({
          value: client.client_id,
          label: client.client_name
        })),
      };
  case FETCH_ACTIVE_CLIENT_FAILURE:
    return {
      ...state,
      loading: false,
      error: action.payload,
    };
    
    case FETCH_TIMESHEET_GET_ACCOUNT_LIST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case FETCH_TIMESHEET_GET_ACCOUNT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        accountList: action.payload,
        success: false,
      };

    case FETCH_TIMESHEET_GET_ACCOUNT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

      
    default:
      return state;
  }
};

export default timesheetSetupClientReducer;
